import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_einvoice_printable_email_content_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  thread_guid: fromDatatype.GuidDataFieldInterface;
  to_list: fromDatatype.TextDatatypeInterface;
  cc: fromDatatype.TextDatatypeInterface;
  bcc: fromDatatype.TextDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  html_body: fromDatatype.TextDatatypeInterface;
  text_body: fromDatatype.TextDatatypeInterface;
  sender_email: fromDatatype.VarcharDatatypeInterface;
  attachments: fromDatatype.TextDatatypeInterface;
  send_time: fromDatatype.TimestampTzDatatypeInterface;
  email_status: fromDatatype.VarcharDatatypeInterface;
  recipient_count: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: any;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: any;
  acl_policy: any;
}

export class bl_fi_einvoice_printable_email_content_RowClass implements bl_fi_einvoice_printable_email_content_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  thread_guid: fromDatatype.GuidDataFieldInterface;
  to_list: fromDatatype.TextDatatypeInterface;
  cc: fromDatatype.TextDatatypeInterface;
  bcc: fromDatatype.TextDatatypeInterface;
  language_code: fromDatatype.VarcharDatatypeInterface;
  html_body: fromDatatype.TextDatatypeInterface;
  text_body: fromDatatype.TextDatatypeInterface;
  sender_email: fromDatatype.VarcharDatatypeInterface;
  attachments: fromDatatype.TextDatatypeInterface;
  send_time: fromDatatype.TimestampTzDatatypeInterface;
  email_status: fromDatatype.VarcharDatatypeInterface;
  recipient_count: fromDatatype.NumericDatatypeInterface;
  priority: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: any;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: any;
  acl_policy: any;
}